import { ButtonPrimeReact, NoData } from "@finanedi.es/storybook"
import { STYLES } from "common/constants/styles"
import { useTranslation } from "react-i18next"

type NoDataTemplateProps = {
  actionLabel: string
  actionCommand?: () => void
  icon: string
  title: string
  description: string
  showActions?: boolean
}

const NoDataTemplate = ({
  actionLabel = "",
  actionCommand,
  icon = "",
  title = "",
  description = "",
  showActions = true,
}: NoDataTemplateProps) => {
  const { t } = useTranslation()

  const emptyTableActions = (
    <div className='tw-flex tw-justify-center'>
      <ButtonPrimeReact
        className={STYLES.tables.actions.create}
        onClick={actionCommand}
      >
        {t(actionLabel)}
      </ButtonPrimeReact>
    </div>
  )
  return (
    <NoData
      icon={icon}
      title={t(title) || ""}
      description={
        t(description, {
          document: t(title).toLowerCase(),
        }) || ""
      }
      actions={showActions ? emptyTableActions : undefined}
    />
  )
}

export default NoDataTemplate
